import { FormGroup, FormLabel } from 'react-bootstrap';
import styled from 'styled-components';

export type TextAlign = 'left' | 'center' | 'right';

export const Container = styled(FormGroup)`
  width: 100%;
  margin-top: 0.5rem;
`;

export const Label = styled(FormLabel)`
  color: ${({ theme }) => theme.colors.botaoConfirmar};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 0.35rem;
`;

export const Required = styled.span`
  color: ${({ theme }) => theme.colors.vermelho};
  font-weight: bold;
`;

export const InputWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  width: 100%;
  align-items: stretch;
  opacity: ${({ disabled }) => (disabled ? 0.85 : 1)};
`;

interface PasswordInputProps {
  textAlign: TextAlign;
  hasToggle: boolean; // aqui significa: "tem algum botão do lado direito"
  disabled?: boolean;
}

export const PasswordInput = styled.input<PasswordInputProps>`
  flex: 1;
  width: 100%; /* <- garante ocupar a largura */
  min-width: 0;

  padding: 0.375rem 0.75rem;
  min-height: 38px;

  border: 1px solid ${({ theme }) => theme.colors.bordaInput};
  border-right: ${({ hasToggle, theme }) =>
    hasToggle ? '0' : `1px solid ${theme.colors.bordaInput}`};

  border-radius: ${({ hasToggle }) => (hasToggle ? '10px 0 0 10px' : '10px')};

  text-align: ${({ textAlign }) => textAlign};

  background-color: ${({ disabled, theme }) =>
    disabled ? '#ebf0f8' : theme.colors.white};

  color: ${({ disabled }) => (disabled ? '#6c757d' : 'inherit')};

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: #9ea4b0;
  }
`;

type ToggleButtonVariant = 'toggle' | 'login' | 'recover';

export const ToggleButton = styled.button<{
  active?: boolean;
  variant?: ToggleButtonVariant;
}>`
  border: 1px solid ${({ theme }) => theme.colors.bordaInput};

  /* sempre colado no input ou no botão anterior */
  border-left: 1px solid ${({ theme }) => theme.colors.bordaInput};

  /* ✅ só o ÚLTIMO botão deve ter canto arredondado */
  border-radius: ${({ variant }) =>
    variant === 'login' || variant === 'recover' ? '0 10px 10px 0' : '0px'};

  background: ${({ theme, variant }) =>
    variant === 'login' ? theme.colors.azulgov : 'transparent'};

  padding: 0 0.75rem;
  min-height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme, active, variant }) =>
    active
      ? theme.colors.botaoLaranja
      : variant === 'login'
        ? theme.colors.white
        : theme.colors.botaoConfirmar};

  cursor: pointer;
  transition: color 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(0.98);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background: #ebf0f8;
  }
`;

export const Icon = styled.span`
  font-size: 1.2rem;
  line-height: 1;
`;

/* ✅ "Esqueci a senha" como texto pequeno alinhado à direita */
export const ForgotPasswordWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
`;

export const ForgotPasswordLink = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;

  font-size: 0.82rem;
  font-weight: 600;

  color: ${({ theme }) => theme.colors.azulgov};

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
  }
`;
